import React, { useState, useEffect, useRef } from "react";

const delay = 30000; // مدت زمان تا جابجایی خودکار (3 ثانیه)

const items = [
  {
    element: <img id="sliderImage1" src={'./images/image33.jpg'} alt="slide1" />
  },
  {
    element: <img id="sliderImage2" src={'./images/image22.jpg'} alt="slide2" />
  },
  {
    element: <img id="sliderImage3" src={'./images/image33.jpg'} alt="slide3" />
  }
];

export default function ImageSlider() {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      setIndex((prevIndex) => (prevIndex === items.length - 1 ? 0 : prevIndex + 1));
    }, delay);

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <div id="sliderContainer">
      <div
        id="sliderTrack"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {items.map((item, idx) => (
          <div id={`sliderSlide${idx + 1}`} key={idx}>
            {item.element}
          </div>
        ))}
      </div>

      <div id="sliderDots">
        {items.map((_, idx) => (
          <div
            key={idx}
            id={`sliderDot${idx + 1}`}
            className={`sliderDot ${index === idx ? "active" : ""}`}
            onClick={() => setIndex(idx)}
          ></div>
        ))}
      </div>
    </div>
  );
}
